import { Card, Flex } from '@opendoor/bricks/core';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import trackEvent from '../helpers/trackEvent';
import { ContentWrapper } from './ContentWrapper';
import DownloadLink from './DownloadLink';

const HOMEBUILDER_ONEPAGER_HREF =
  'https://odfil.es/static/partnership-dashboard/HB_SalesAssociate_Sheeter.pdf';
const AGENT_EDUCATIONAL_ONEPAGER =
  'https://odfil.es/static/partnership-dashboard/OpendoorForAgents_AgentAccess_One-sheeter_Final_Q423.pdf';

const DocumentsSection = () => {
  const trackDownload = (label: string) => () => {
    trackEvent('download', label, {});
  };

  return (
    <ContentWrapper>
      <ContentCard title="Additional resources" borderRadius="roundedSquare">
        <Flex flexDirection="column">
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
            mb={5}
          >
            <DownloadLink
              href={HOMEBUILDER_ONEPAGER_HREF}
              onClick={trackDownload('marketing-material')}
            >
              Download Homebuilder One Pager Marketing Material (PDF)
            </DownloadLink>
          </Card>
          <Card
            border="1px solid"
            borderColor="neutrals40"
            borderRadius="squared"
            width="100%"
            pl={5}
          >
            <DownloadLink
              href={AGENT_EDUCATIONAL_ONEPAGER}
              onClick={trackDownload('agent-educational-onepager')}
            >
              Download Agent Educational One Pager (PDF)
            </DownloadLink>
          </Card>
        </Flex>
      </ContentCard>
    </ContentWrapper>
  );
};

export default DocumentsSection;
